module.exports = __webpack_public_path__ + "img/logo-jnj-regular.7df7f705.svg";